import React, { Component } from 'react'
import botImg from '../assets/images/botHead2.png'

class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      named: '',
      value: 1,
    }
  }

  render() {
    const { txt } = this.props
    return (
      <div className='header'>
        <img src={botImg} alt='bot' />
        <div>{txt.header}</div>
      </div>
    )
  }
}
export default Header
